import React, { useId } from 'react'
import PropTypes from 'prop-types'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

const ToolTip = ({
  children,
  id = useId(),
  placement = 'top',
  overlayText,
  trigger
}) => (
  <OverlayTrigger
    placement={placement}
    trigger={trigger}
    delay={{ show: 100, hide: 200 }}
    overlay={
      <Tooltip id={id}>
        <div className={typeof overlayText === 'string' && overlayText.length <= 15 ? 'text-center' : 'text-start'}>
          {overlayText}
        </div>
      </Tooltip>
    }>
    {children}
  </OverlayTrigger>
)

ToolTip.propTypes = {
  id: PropTypes.any,
  placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  overlayText: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string
  ]),
  trigger: PropTypes.oneOf(['hover', 'focus']),
  children: PropTypes.node
}

export default ToolTip
